/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLessonCurriculumOutcomesApi } from "@/api/reportingApi";
import { LessonCurriculumOutcome } from "@/ts/interfaces/Reporting/api/LessonCurriculamInterface";

export const getLessonCurriculumOutcomesThunk = createAsyncThunk<
    LessonCurriculumOutcome[],
    number,
    { rejectValue: string }
>("reporting/lessonCurriculum", async (lessonId, { rejectWithValue }) => {
    try {
        const response = await getLessonCurriculumOutcomesApi(lessonId);
        return response.data?.data ?? [];
    } catch (err: any) {
        return rejectWithValue(err?.response?.data?.message || "Failed to load curriculum outcomes.");
    }
});
